import React, { Component } from 'react';
// import Dropzone from 'react-dropzone'

import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class GeneralDetails extends Component {

	@observable error = false
	@observable loading = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 9 - 1
	}

	@computed get completed() {
		// const { doctor } = this.props.store
		return true
	}

	handleNext = async () => {
		this.loading = true 
		const submitting = await this.props.store.submitNewListing()
		setTimeout(() => {
			if (submitting) {
				this.props.history.push(`/listing/complete`)
			} else {
				this.error = true
				this.loading = false 
			}
		}, 1000);
    }

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	render() {
		const { doctor } = this.props.store
		
		return (
			<div>
				
				<h2 >8. Additional Details</h2>
				<p>Please feel free to complete this final section for some additional information about yourself.</p>
				<h4>
					Languages spoken
				</h4>	
				{doctor.languagesSpoken && doctor.languagesSpoken.map((theLanguage, index) =>
					<div key={index} className="m-b-1">
						<input
							className={`input medium m-r-1`}
							type="email"
							disabled={this.loading}
							placeholder="Chinese (Mandarin)..."
							value={theLanguage.title} 
							onChange={e => { theLanguage.title = e.target.value; }}
						/>
						<div className={`btn sm ${this.loading ? "disabled" : "base"}`} onClick={()=>doctor.languagesSpoken.splice(index,1)}><i className="fa fa-fw fa-times"></i> Remove</div>
					</div>)}
				<div>
					<div
						onClick={()=>doctor.languagesSpoken.push({ title: ""})}
						className={`btn sm m-b-1 ${this.loading ? "disabled" : null }`}><i className="fa fa-fw fa-plus"></i> Add Language</div>	
				</div>
				<h4>
					Additional notes
				</h4>	
				<textarea
					className="input"
					cols="30"
					disabled={this.loading}
					rows="10"
					placeholder="If there are any other items you wish to add..."
					value={doctor.additionalNotes}
					onChange={e=>doctor.additionalNotes=e.target.value}
					></textarea>
				<div className="m-t-1">
					<div
						onClick={this.loading ? null : this.handlePrev}	
						className={`btn m-r-1 ${this.loading ? "disabled" : "base"}`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.loading ? null : this.handleNext}	
						className={`btn lg  ${this.loading ? "disabled" : "secondary"} ${!this.completed && 'disabled'}`}>
						<i className={`fa fa-fw ${this.loading ? "fa-cog fa-spin" : "fa-check"}`}></i>
						{this.loading ? "Loading" : "Submit Form"}
					</div>

					{!this.error || <h4 className="error">It seems to be something went wrong. Please contact us on 0401 011 207.</h4>}			

					<p className="m-t-1 m-b-1 ">Please <u>double check</u> your listing details are all correct before submitting, as they will be printed in the next paper publication as well as listed online for GP referrals. </p>
				</div>
			</div>
		);
	}
}

export default GeneralDetails;


// WEBPACK FOOTER //
// ./src/Containers/Listing/9.AdditionalDetails.js